import {ReactNode} from 'react';
import {Text, BlockStack, Box} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';

import {SearchIllustration} from './illustrations';
import styles from './NoResults.scss';

export function NoResults({
  heading,
  body,
}: {
  heading?: string;
  body?: ReactNode;
}) {
  const [i18n] = useI18n();
  const bodyMarkup = body ? (
    <Text as="p" tone="subdued" alignment="center">
      {body}
    </Text>
  ) : undefined;

  return (
    <div className={styles.NoResults}>
      <Box padding="200">
        <BlockStack gap="100" align="center" inlineAlign="center">
          <img
            className={styles.NoResultsImage}
            src={SearchIllustration}
            alt=""
          />
          <Text as="p" variant="headingMd" alignment="center">
            {heading || i18n.translate('Common.noResults')}
          </Text>
          {bodyMarkup}
        </BlockStack>
      </Box>
    </div>
  );
}
